module.exports = __webpack_public_path__ + "static/media/reedSoumn916.a3a6066f.ico";